var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "orderInfo",
      attrs: {
        title: "【" + _vm.info.orderNo + "】" + " 订单详情",
        "close-on-click-modal": false,
        visible: _vm.visible,
        width: "68%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "order-contain" }, [
        _c(
          "div",
          { staticClass: "order-info" },
          [
            _c("span", { staticClass: "title" }, [_vm._v("状态信息")]),
            _c(
              "el-form",
              { attrs: { inline: true, "label-width": "120px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "订单编号:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.orderNo) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "订单状态:" } },
                          [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("statusFilters")(
                                      _vm.info.orderStatus
                                    )
                                  )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "order-info" },
          [
            _c("span", { staticClass: "title" }, [_vm._v("乘客信息")]),
            _c(
              "el-form",
              { attrs: { inline: true, "label-width": "130px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 28 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "出发地:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.startAddress) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "目的地:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.endAddress) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "预计出发时间:" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.orderDepart) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 28 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "公里数:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.distance) +
                              " 公里\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "预计出行人数:" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.passengerNumber) +
                                " 人\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "乘车人姓名：" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.passengerName) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "乘车人电话：" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.passengerPhone) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "下单人姓名：" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.userName) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "下单人电话：" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.userPhone) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 10 } },
                      [
                        _c("el-form-item", { attrs: { label: "备注:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.orderRemark) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "order-info" },
          [
            _c("span", { staticClass: "title" }, [_vm._v("支付信息")]),
            _c(
              "el-form",
              { attrs: { inline: true, "label-width": "110px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "支付时间:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.paySuccessTime) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "预付金额:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.payAmount) +
                              " 元\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "接单金额:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.acceptOrderAmount) +
                              " 元\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "差价退款金额:" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.systemRefundAmount) +
                                " 元\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "支付渠道:" } },
                          [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("payTypeFilters")(_vm.info.payType)
                                )
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "手动退款金额:" } },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.info.adminRefundAmount) +
                                " 元\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "订单余额:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.surplusAmount) +
                              " 元\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "order-info" }, [
          _c("span", { staticClass: "title" }, [_vm._v("服务信息")]),
          _c(
            "div",
            { staticStyle: { padding: "10px 0 0 20px" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.info.driverOperationInfoList, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "供应商信息", prop: "merchantName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "司机姓名", prop: "driverName" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "司机手机号码", prop: "driverPhone" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "车牌号", prop: "plateNumber" },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "状态", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("serviceStatusFilter")(
                                    scope.row.operationStatus
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: { label: "备注", prop: "operationRemark" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "order-info" }, [
          _c("span", { staticClass: "title" }, [_vm._v("退款信息")]),
          _c(
            "div",
            { staticStyle: { padding: "10px 0 0 20px" } },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: { data: _vm.info.orderRefundInfoList, border: "" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "编号",
                      prop: "orderNo",
                      width: "130",
                      align: "left",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "退款时间",
                      prop: "successTime",
                      width: "180",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "退款金额",
                      prop: "refundAmount",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "退款类型",
                      prop: "source",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm._f("serviceStatusFilter")(
                                    scope.row.source
                                  )
                                )
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "违约金",
                      prop: "serviceCharge",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作人",
                      prop: "createUserName",
                      width: "80",
                      align: "center",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "备注", prop: "remark", align: "center" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "order-info" },
          [
            _c("span", { staticClass: "title" }, [_vm._v("开票信息")]),
            _c(
              "el-form",
              { attrs: { inline: true, "label-width": "110px" } },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "开票状态:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.invoiceStatus) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "开票金额:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.invoiceAmount) +
                              " 元\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "开票时间:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.invoiceCreateTime) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 24 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "开票类型:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.invoiceType) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c("el-form-item", { attrs: { label: "开票信息:" } }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.info.invoiceInfo) +
                              "\n            "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }